import { render } from "./RejectedDowngrade.vue?vue&type=template&id=013d0d2e"
import script from "./RejectedDowngrade.vue?vue&type=script&lang=js"
export * from "./RejectedDowngrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__